import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { contactKeys, creditMemoKeys } from '@/lib/queryKeys';
import { creditMemoEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api/client';

interface ApproveResult {
  id: string;
  status: string;
}

export function useApproveCreditMemo() {
  const queryClient = useQueryClient();

  return useApiMutation<ApproveResult, string>({
    mutationFn: (id) =>
      apiPost<ApproveResult, Record<string, never>>(
        operationsClient,
        creditMemoEndpoints.approve(id),
        {},
      ),
    onSuccess: () => {
      // Approval releases the memo's credit to the customer: it joins their
      // available credit, the "Apply memo" suggestions and the customer
      // summary's memo credit. The response only names the memo, not its
      // customer, so refresh every customer's details.
      void queryClient.invalidateQueries({ queryKey: creditMemoKeys.all() });
      void queryClient.invalidateQueries({ queryKey: contactKeys.details() });
      toast.success('Credit memo approved');
    },
  });
}
